import Multiselect, { type MultiselectOption } from '@rio-cloud/rio-uikit/Multiselect';

import { OrderStatus } from '@/features/chargingCards/history/OrderBody';
import { t } from '@/lib/utils';

export type OrderStatusKey = keyof typeof OrderStatus;

export const ORDER_STATUS_KEYS = Object.keys(OrderStatus) as OrderStatusKey[];

export type OrderStatusFilterProps = {
    value: OrderStatusKey[];
    onChange: (selected: OrderStatusKey[]) => void;
};

const buildOptions = (value: OrderStatusKey[]): MultiselectOption[] =>
    ORDER_STATUS_KEYS.map(key => ({
        id: key,
        label: t(OrderStatus[key].value),
        selected: value.includes(key),
        icon: <span className={`uikit-icon ${OrderStatus[key].icon} margin-right-5`} aria-hidden='true' />,
    }));

const OrderStatusFilter = ({ value, onChange }: OrderStatusFilterProps) => {
    const handleChange = (selectedIds: string[]) => {
        const selected = selectedIds.filter((id): id is OrderStatusKey =>
            ORDER_STATUS_KEYS.includes(id as OrderStatusKey)
        );

        // At least one order status must always be selected.
        // Deselecting everything re-selects all options.
        onChange(selected.length === 0 ? [...ORDER_STATUS_KEYS] : selected);
    };

    return (
        <Multiselect
            id='order-status-filter'
            aria-label={t('orderHistory.orderStatus')}
            placeholder={t('orderHistory.orderStatus')}
            options={buildOptions(value)}
            value={value}
            onChange={handleChange}
            className='min-width-400'
        />
    );
};

export default OrderStatusFilter;
